import { gsap } from 'gsap'
export default class BankingAiHero {
    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        this.svg = this.el.querySelector('svg')
        this.waves = this.el.querySelector('.banking-ai-hero--waves')
        this.animateLetters = false;
        this.animateDots = false;
        this.updatesDelay = 100;
        this.prevUpdateTime = Date.now();
        this.stateColors = [
            '#FFFFFF',
            '#FFFF40',
        ]
        this.initLetters()
        this.initDots()
        this.showScene()
        this.initDotsAnimation()
        this.initLettersAnimation()
        this.bind();
        this.render();
    }

    bind() {
        this.render = this.render.bind(this);
    }

    showScene() {
        gsap.to(this.svg, {alpha: 1, duration: 1})
        gsap.to(this.waves, {alpha: 1, duration: 1})

    }

    initDots() {
        const paths = this.el.querySelectorAll('.banking-dot path')
        gsap.set(paths, {alpha: 0})

        this.dots = [...this.el.querySelectorAll('.banking-dot g')]

        this.dots.sort(() => Math.random() - 0.5)
    }

    initDotsAnimation() {
        this.dotsTimeline = gsap.timeline({
            repeat: 0,
            onComplete: () => {
                this.animateDots = true;
            }
        })

        this.dots.forEach((dot, idx) => {
            const children = [...dot.children]

            children.forEach((child) => {
                const destAlpha = child.classList.contains('banking-dot-inner') ? .4 : 1;
                this.dotsTimeline
                    .to(child, {duration: 0.5, alpha: destAlpha}, idx * 0.1)
            })
        })
    }

    initLetters() {
        this.words = this.el.querySelectorAll('.banking-letters')
        this.lettersAll = this.el.querySelectorAll('.banking-letters path')
        this.animatedLetters = [...this.el.querySelectorAll('.banking-letters-animate g')]
        this.staticWords = [...this.el.querySelectorAll('.banking-letters:not(.banking-letters-animate)')]

        gsap.set(this.lettersAll, {alpha: 0})
    }

    initLettersAnimation() {
        this.wordsTimline = gsap.timeline({
            repeat: 0,
            onComplete: () => {
                this.animateLetters = true;
            }
        })

        const wordsDelay = 0.3;
        const lettersDelay = 0.1;
        let wordsCount = 0

        this.words.forEach((word, wordIdx) => {
            const letters = [...word.querySelectorAll('g')]
            letters.forEach((letter, letterIdx) => {
                const childrenIdx = Math.round(Math.random())
                this.wordsTimline
                    .to(letter.children[childrenIdx], {duration: 0.5, alpha: 1}, wordIdx * wordsDelay + letterIdx * lettersDelay)
            })
            wordsCount++;
        })

        this.staticWords.forEach((word, wordIdx) => {
            const letters = [...word.querySelectorAll('path')]
            letters.reverse()

            letters.forEach((letter, letterIdx) => {
                this.wordsTimline
                    .to(letter, {duration: 0.5, alpha: 1}, (wordsCount + wordIdx) * wordsDelay + letterIdx * lettersDelay)
            })
        })
    }

    updateDots() {
        if(!this.animateDots) return;

        let dotToAnimateId = Math.floor(Math.random() * this.dots.length)
        while (dotToAnimateId === this.dotToAnimatePrev) {
            dotToAnimateId = Math.floor(Math.random() * this.dots.length)
        }

        this.dotToAnimatePrev = dotToAnimateId;
        const dotToAnimate = this.dots[dotToAnimateId]
        const state = dotToAnimate.classList.contains('dot-enabled') ? 0 : 1
        const color = this.stateColors[state]
        const children = [...dotToAnimate.children];
        const timeline = gsap.timeline()
        dotToAnimate.classList.toggle('dot-enabled')
        children.forEach((child) => {
            if(child.classList.contains('banking-dot-inner')) {

                timeline.to(child, {duration: 0.25, attr: {
                        fill: color
                    }
                }, 0)
            } else {
                timeline.to(child, {duration: 0.25, attr: {
                        stroke: color
                    }
                }, 0)
            }
        })
    }

    updateLetter() {
        if(!this.animateLetters) return;

        let letterToAnimateId = Math.floor(Math.random() * this.animatedLetters.length)
        while (letterToAnimateId === this.letterToAnimatePrev) {
            letterToAnimateId = Math.floor(Math.random() * this.animatedLetters.length)
        }

        this.letterToAnimatePrev = letterToAnimateId;
        const letterToAnimate = this.animatedLetters[letterToAnimateId]
        const childrenToShow = Math.round(Math.random())
        const childrenToHide = childrenToShow === 0 ? 1 : 0
        const children = [...letterToAnimate.children]
        gsap.timeline()
            .to(children[childrenToShow], {duration: 0.5, alpha: 1}, 0)
            .to(children[childrenToHide], {duration: 0.5, alpha: 0}, 0)
    }

    render() {
        this.update();
        requestAnimationFrame(this.render);
    }

    update() {
        const currentTime = Date.now();
        const deltaTime = currentTime - this.prevUpdateTime;

        if(deltaTime > this.updatesDelay) {
            this.prevUpdateTime = currentTime;
            this.updateLetter()
            this.updateDots()
        }
    }
}
